import { motion } from 'framer-motion';
import SectionHeading from './SectionHeading';

// ✅ Import directo de la imagen local
import aboutTeamImage from '@/assets/images/about-team.jpg';

const cards = [
  {
    title: 'MISIÓN',
    description:
      'Generar beneficios mediante un servicio honesto e integral para que tu empresa mantenga la imagen limpia que esperas.',
  },
  {
    title: 'VISIÓN',
    description:
      'Ser una empresa líder en mejora continua, desarrollando técnicas, habilidades, tecnología y actitud proactiva.',
  },
  {
    title: 'VALORES',
    description:
      'Servicio al cliente · Trabajo en equipo · Honestidad · Comunicación · Compromiso',
  },
];

const About = () => {
  return (
    <section id="nosotros" className="bg-white py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="grid items-center gap-14 lg:grid-cols-2">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="relative"
          >
            <img
              src={aboutTeamImage}
              alt="Personal profesional de limpieza trabajando"
              className="aspect-[4/5] w-full object-cover lg:aspect-[4/3]"
            />
            <div className="absolute -bottom-6 -right-3 px-7 py-5 text-white bg-[#94cf1c]">
              <b className="block text-3xl">20 años</b>
              <span className="text-sm">de experiencia operativa</span>
            </div>
          </motion.div>

          <div>
            <SectionHeading
              eyebrow="Nuestra empresa"
              title="¿QUIÉNES SOMOS?"
              text="Somos un equipo enfocado en generar beneficios para nuestros clientes y todos los que conformamos la empresa, mediante un servicio honesto e integral para que tu empresa mantenga la imagen limpia que esperas."
            />

            <div className="mt-9 grid gap-4">
              {cards.map((card) => (
                <div
                  key={card.title}
                  className="border-l-4 border-emerald-500 bg-slate-50 p-5"
                >
                  <h3 className="font-bold tracking-wide text-[#00a7e2]">
                    {card.title}
                  </h3>
                  <p className="mt-2 leading-7 text-slate-600 text-justify">
                    {card.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;